export default function PHP_xml_get_current_column_number() {
  return (
    <div>
      <h1>PHP_xml_get_current_column_number</h1>
    </div>
  );
}
